import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */
export default class User {
  constructor() {
    log.info('[INFO] Initialize Commission User Module')
  }

  fetchAllUserValues(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    return new Promise((resolve, reject) => {
      axios
        .get('v1/commission/commission/total/from/user/', parameters)
        .then(response => {
          log.debug('[DEBUG] Success to fetch all user values')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch all user values')
          log.error(error)
          reject(error.response)
        })
    })
  }

  fetchUserValues(uuid, params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    return new Promise((resolve, reject) => {
      axios
        .get(`v1/commission/commission/total/from/user/${uuid}/`, parameters)
        .then(response => {
          log.debug('[DEBUG] Success to fetch user values')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch user values')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
